// Programs page data

export const RAZORPAY_PAYMENT_LINK = "https://rzp.io/rzp/j10Inl3m";

export const programLevels = [
  {
    level: 1,
    title: "Foundation: Market Literacy",
    sessions: 20,
    duration: "10 Weeks",
    cohortSize: "20 Students Maximum",
    
    whoItsFor: [
      "Teenagers aged 13-17 with no prior market knowledge",
      "Students curious about how financial systems work",
      "Parents seeking structured financial education for their child"
    ],
    
    transformation: "Students transition from complete beginners to understanding market structures, financial instruments, and basic risk concepts. They develop the ability to read financial news critically and understand economic cause-and-effect relationships.",
    
    deliverables: [
      "Market Structure Worksheets",
      "Weekly Reading & Analysis Homework",
      "Financial Literacy Assessment",
      "Personal Investment Philosophy Template"
    ],
    
    outcome: "Students gain foundational knowledge of markets, understand basic financial instruments, and develop critical thinking about money and investing decisions."
  },
  {
    level: 2,
    title: "Applied: Strategy & Systems Thinking",
    sessions: 25,
    duration: "13 Weeks",
    cohortSize: "20 Students Maximum",
    
    whoItsFor: [
      "Students who have completed Level 1 or have equivalent foundational knowledge",
      "Teenagers aged 14-17 ready for structured analytical frameworks",
      "Students interested in understanding trading systems and risk management"
    ],
    
    transformation: "Students learn to think in systems, understand probability-based decision making, and develop structured analytical frameworks. They move from theory to practical application through simulated scenarios and real chart analysis.",
    
    deliverables: [
      "Trading Journal Template",
      "Strategy Framework Worksheets",
      "Backtesting Template & Case Studies",
      "Risk Management Calculator",
      "Market Scenario Analysis Projects"
    ],
    
    outcome: "Students develop systematic thinking, understand risk-reward frameworks, and can analyze market scenarios with structured logic rather than emotion."
  },
  {
    level: 3,
    title: "Advanced: Professional Risk & Capital Mastery",
    sessions: 20,
    duration: "10 Weeks",
    cohortSize: "20 Students Maximum",
    
    whoItsFor: [
      "Students who have completed Level 2",
      "Teenagers aged 15-17 ready for professional-grade frameworks",
      "Students preparing for finance-related academic or career paths"
    ],
    
    transformation: "Students learn institutional-grade risk management, portfolio construction principles, and capital allocation strategies. They complete a capstone project building and testing their own systematic approach to markets.",
    
    deliverables: [
      "Advanced Risk Management Framework",
      "Portfolio Construction Templates",
      "Strategy Simulation Reports",
      "Capstone System Design Project",
      "Professional Trading Psychology Workbook"
    ],
    
    outcome: "Students gain professional-level understanding of risk management, capital preservation, and systematic decision-making. They complete the program with a fully documented systematic approach and institutional thinking mindset."
  }
];

export const howWeTeach = [
  {
    title: "Story-Based Learning",
    description: "Complex concepts taught through real-world narratives and case studies that students can relate to and remember."
  },
  {
    title: "Interactive Live Sessions",
    description: "Active participation, real-time Q&A, and collaborative learning in small cohorts of 20 students maximum."
  },
  {
    title: "Real Chart Analysis",
    description: "Students work with actual market data, charts, and scenarios to develop practical analytical skills."
  },
  {
    title: "Structured Frameworks",
    description: "Every concept is taught using clear, repeatable frameworks that students can apply independently."
  },
  {
    title: "Case Studies",
    description: "Historical market events, successful strategies, and common mistakes analyzed in detail for deep learning."
  },
  {
    title: "Capstone System-Building Project",
    description: "Students design, document, and test their own systematic approach, demonstrating mastery of all concepts learned."
  }
];

export const whyParentsTrust = [
  {
    title: "Educational Focus",
    description: "Structured curriculum designed for long-term thinking and foundational knowledge, not quick profits."
  },
  {
    title: "No Stock Tips",
    description: "We teach frameworks and thinking systems, never specific stock recommendations or 'hot tips'."
  },
  {
    title: "No Investment Advice",
    description: "This is education, not advisory. Students learn concepts, not where to invest their money."
  },
  {
    title: "Discipline Over Speculation",
    description: "Focus on risk awareness, capital preservation, and systematic decision-making rather than gambling mentality."
  },
  {
    title: "Structured Thinking",
    description: "Emphasis on analytical frameworks, probability-based reasoning, and long-term strategic thinking."
  },
  {
    title: "Parent Involvement",
    description: "Regular updates, transparent curriculum, and parent orientation to ensure alignment with family values."
  }
];
